module.exports = __webpack_public_path__ + "img/sun.62664fbb.svg";